import { jsx as o } from "react/jsx-runtime";
import { createContext as r } from "react";
var e = (t) => /* @__PURE__ */ o("a", { ...t }), n = r({ link: e });
export {
  n as FooterLinkContext,
  e as defaultLink
};
